export const blacklistedPatterns = [
  '00',
  '12',
  '34',
  '56',
  '78',
  'ab',
  'qw',
  'asd',
  'zxc',
  'pass',
  'p@ss',
  'word',
  'w0rd',
  'key',
  'trust',
  'bang',
  'ball',
  'iop',
  'jkl',
  'bnm',
  'omg',
  'lol',
];
